import React from 'react';
import { createIconComp } from './createIconComp';

const icon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_43047_15925)">
    <path d="M19.232 12H12.768C12.3438 12 12 12.3438 12 12.768V19.232C12 19.6562 12.3438 20 12.768 20H19.232C19.6562 20 20 19.6562 20 19.232V12.768C20 12.3438 19.6562 12 19.232 12Z" fill="currentColor"/>
    <path opacity="0.45" d="M16.0001 30.3996C23.953 30.3996 30.4001 23.9525 30.4001 15.9996C30.4001 8.04671 23.953 1.59961 16.0001 1.59961C8.0472 1.59961 1.6001 8.04671 1.6001 15.9996C1.6001 23.9525 8.0472 30.3996 16.0001 30.3996Z" stroke="#69B1FF" stroke-width="3.2"/>
    <path d="M0.000488281 16C0.000488281 11.6676 1.72408 7.73402 4.52002 4.85449L6.81592 7.08398C4.57643 9.39045 3.19971 12.533 3.19971 16C3.19981 19.4668 4.57657 22.6087 6.81592 24.915L4.52002 27.1445C1.72418 24.2651 0.000592173 20.3322 0.000488281 16Z" fill="currentColor">
      <animateTransform attributeName="transform"
                        type="rotate"
                        from="0 16 16"
                        to="360 16 16"
                        dur="3s"
                        repeatCount="indefinite"/>
    </path>
  </g>
  <defs>
    <clipPath id="clip0_43047_15925">
      <rect width="32" height="32" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;


export const LoadingIcon = createIconComp({ icon });
